import { AXIS_COLORS } from '../constants';
export const dimensions = [{
  name: 'length',
  color: AXIS_COLORS.zAxis,
  rectangle: 'lengthRectangle',
  label: 'lengthLabel',
  container: 'lengthContainer'
}, {
  name: 'height',
  color: AXIS_COLORS.yAxis,
  rectangle: 'heightRectangle',
  label: 'heightLabel',
  container: 'widthContainer'
}, {
  name: 'width',
  color: AXIS_COLORS.xAxis,
  rectangle: 'widthRectangle',
  label: 'widthLabel',
  container: 'heightContainer'
}];